import React from 'react';
import { useLocation } from 'react-router-dom';
import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { Accordion, AccordionItem, AccordionTrigger } from './ui/accordion';
import GUIDES from '../data/pageGuides.json';

export const PageGuide = () => {
  const { pathname } = useLocation();
  const g = GUIDES[pathname.replace(/\/$/, '') || '/'];
  if (!g) return null;
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-8 py-12" data-testid="page-guide">
      <h2 className="text-2xl sm:text-3xl font-bold text-[#064E3B] mb-6" data-testid="page-guide-title">{g.title}</h2>
      <div className="bg-white rounded-3xl shadow-md border border-gray-100 p-6 sm:p-8 space-y-4">
        {g.guide.map((para, i) => (
          <p key={i} className="text-sm sm:text-base text-gray-700 leading-relaxed" data-testid={`page-guide-para-${i}`}>
            {para.map(([t, b], j) => (b ? <strong key={j} className="text-[#064E3B]">{t}</strong> : <React.Fragment key={j}>{t}</React.Fragment>))}
          </p>
        ))}
      </div>
      <h2 className="text-2xl sm:text-3xl font-bold text-[#064E3B] mt-12 mb-6" data-testid="page-guide-faq-title">FAQ</h2>
      <Accordion type="multiple" className="bg-white rounded-3xl shadow-md border border-gray-100 px-6 sm:px-8" data-testid="page-guide-faq">
        {g.faqs.map((f, i) => (
          <AccordionItem key={i} value={`q${i}`} className={i === g.faqs.length - 1 ? 'border-b-0' : ''}>
            <AccordionTrigger className="text-base font-bold text-[#064E3B] hover:no-underline hover:text-[#65A30D]" data-testid={`page-guide-faq-q-${i}`}>{f.q}</AccordionTrigger>
            <AccordionPrimitive.Content forceMount className="overflow-hidden data-[state=closed]:hidden" data-testid={`page-guide-faq-a-${i}`}>
              <p className="pb-4 text-sm text-gray-600 leading-relaxed">{f.a}</p>
            </AccordionPrimitive.Content>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default PageGuide;
